import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/core/components/ui/button";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";

export function ScrollToTop() {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const { t } = useTypedTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 320);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Button
      size="icon"
      className={cn(
        "fixed bottom-8 right-4 z-50 cursor-pointer rounded-full transition-all duration-200",
        { "scale-0": !showScrollButton }
      )}
      onClick={scrollToTop}
      aria-label={t("layout.scrollToTop")}
    >
      <ArrowUp />
      <span className="sr-only">{t("layout.scrollToTop")}</span>
    </Button>
  );
}
